import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatMinutesSeconds'
})
export class FormatMinutesSecondsPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        let timeString = '';
        let hours = Math.floor(Number(value) / (60 * 60));
        let minutes = Math.floor((Number(value) % (60 * 60)) / 60) ;
        let seconds = (Number(value) % (60 * 60)) % 60;

        timeString = `${ hours ? hours + 'h ' : '' }${ minutes ? minutes + 'm ' : '' }${ seconds ? seconds + 's' : '0s' }`;



        return timeString;
    }
}